import type { Exchange } from "../interfaces/Chat";

export function hydrateExchangeMetadata<T extends Record<string, any>>(exchange: T): T {
  let queryMetadata: Record<string, unknown> = {};
  if (typeof exchange.metadata === "string" && exchange.metadata.trim()) {
    try {
      queryMetadata = JSON.parse(exchange.metadata) as Record<string, unknown>;
    } catch {
      queryMetadata = {};
    }
  } else if (exchange.metadata && typeof exchange.metadata === "object") {
    queryMetadata = exchange.metadata as Record<string, unknown>;
  }

  const responseMode =
    typeof queryMetadata.responseMode === "string" ? queryMetadata.responseMode : exchange.responseMode;
  const workflowMetadata = Object.prototype.hasOwnProperty.call(queryMetadata, "workflowMetadata")
    ? (queryMetadata as any).workflowMetadata
    : exchange.workflowMetadata;
  const safetyClassification =
    (queryMetadata as any).safetyClassification ?? workflowMetadata?.safetyClassification ?? exchange.safetyClassification;
  const retrievalDecision =
    (queryMetadata as any).retrievalDecision ?? workflowMetadata?.retrievalDecision ?? exchange.retrievalDecision;
  const conversationMomentum =
    (queryMetadata as any).conversationMomentum ?? workflowMetadata?.conversationMomentum ?? exchange.conversationMomentum;
  const alignment =
    (queryMetadata as any).alignment ?? workflowMetadata?.alignment ?? exchange.alignment;
  const retrievalSummary =
    (queryMetadata as any).retrievalSummary ?? workflowMetadata?.retrievalSummary ?? exchange.retrievalSummary;
  const toolTrace = Object.prototype.hasOwnProperty.call(queryMetadata, "toolTrace")
    ? (queryMetadata as any).toolTrace
    : exchange.toolTrace;
  const goal = Object.prototype.hasOwnProperty.call(queryMetadata, "goal")
    ? (queryMetadata as any).goal
    : exchange.goal;
  const useSynapse =
    typeof queryMetadata.useSynapse === "boolean"
      ? queryMetadata.useSynapse
      : exchange.useSynapse;
  const safetyRoute = queryMetadata.safetyRoute ?? exchange.safetyRoute;
  const seeds = queryMetadata.seeds ?? exchange.seeds;
  const retrievedChunkIds = queryMetadata.retrievedChunkIds ?? exchange.retrievedChunkIds;
  const usedChunkIds = queryMetadata.usedChunkIds ?? exchange.usedChunkIds;

  const comparisonRunId =
    typeof queryMetadata.comparisonRunId === "string" ? queryMetadata.comparisonRunId : exchange.comparisonRunId;
  const comparisonStreamId =
    typeof queryMetadata.comparisonStreamId === "string" ? queryMetadata.comparisonStreamId : exchange.comparisonStreamId;
  const comparisonStreamLabel =
    typeof queryMetadata.comparisonStreamLabel === "string" ? queryMetadata.comparisonStreamLabel : exchange.comparisonStreamLabel;
  const parentChatId =
    typeof queryMetadata.parentChatId === "string" ? queryMetadata.parentChatId : exchange.parentChatId;
  const comparisonSettings =
    queryMetadata.comparisonSettings && typeof queryMetadata.comparisonSettings === "object"
      ? (queryMetadata.comparisonSettings as Record<string, unknown>)
      : exchange.comparisonSettings;

  return {
    ...exchange,
    ...(safetyRoute ? { safetyRoute } : {}),
    ...(seeds ? { seeds } : {}),
    ...(retrievedChunkIds ? { retrievedChunkIds } : {}),
    ...(usedChunkIds ? { usedChunkIds } : {}),
    responseMode,
    workflowMetadata,
    safetyClassification,
    retrievalDecision,
    conversationMomentum,
    alignment,
    retrievalSummary,
    toolTrace,
    goal,
    useSynapse,
    comparisonRunId,
    comparisonStreamId,
    comparisonStreamLabel,
    parentChatId,
    comparisonSettings,
  };
}
